import { LitElement, css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators';

import { ActivePanel } from '../types';

@customElement('drawer-button-component')
export class DrawerButtonComponent extends LitElement {
    @property()
    icon = '';

    @property()
    secondicon = '';

    @property()
    label = '';

    @property()
    panel?: ActivePanel;

    @property()
    action?: Function;

    @property({ type: Boolean })
    hideOnMobile: boolean = false;

    @property({ type: Boolean })
    isAddOnDrawer: boolean = false;

    @property({ type: Boolean })
    isAddOn: boolean = false;

    @property({ type: Boolean })
    highlightPoint: boolean = false;

    @property({ type: Boolean })
    hasChild: boolean = false;

    @property({ type: Boolean })
    isChild: boolean = false;

    @state()
    active: boolean = false;

    @state()
    childOpen: boolean = false;

    @state()
    hidden: boolean = false;

    @state()
    mini: boolean = false;

    @state()
    available: boolean = true;

    render() {
        if (this.hidden) {
            return html``;
        }
        return html`
            <div class="background ${this.active && this.mini ? 'active-background' : ''}">
                <div class="topActive"></div>
            </div>
            <button type="button" class="btn ${this.active ? 'btn-active' : ''} ${this.hideOnMobile ? 'btn--hide-on-mobile' : ''} ${!this.available ? 'locked' : ''}  ${this.isChild ? 'btn--child' : ''}" @click="${this.onClick}" title="${this.mini ? this.label : ''}">
                <div class="wrapper ${this.mini ? 'mini' : ''}">
                    ${!this.isChild || this.mini ? html`
                        <mwc-icon class="${this.highlightPoint ? 'btn--highlighted' : ''}">${this.icon}</mwc-icon>
                        ${this.hasChild && this.childOpen && this.mini ? html`<mwc-icon class="icon--addon-small mini-arrow">keyboard_arrow_up</mwc-icon>` : ''}
                        ${this.hasChild && !this.childOpen && this.mini ? html`<mwc-icon class="icon--addon-small mini-arrow">keyboard_arrow_down</mwc-icon>` : ''}
                    ` : html`
                        <div class="spacer"></div>
                    `}
                    ${!this.mini ? html`
                        <span class="btn__label ${this.isChild ? 'btn__label--child' : 'btn_label--opened'}">
                            ${this.label}
                        </span>
                        ${!this.available ? html`<mwc-icon class="icon--addon-small">lock</mwc-icon>` : ''}
                        ${this.isAddOn ? html`<span class="app-tag">App</span>` : ''}
                        ${this.hasChild && this.childOpen ? html`<mwc-icon class="icon--addon-small">keyboard_arrow_up</mwc-icon>` : ''}
                        ${this.hasChild && !this.childOpen ? html`<mwc-icon class="icon--addon-small">keyboard_arrow_down</mwc-icon>` : ''}
                    ` : ''}
                </div>
            </button>
            <div class="background ${this.active && this.mini ? 'active-background' : ''}">
                <div class="bottomActive"></div>
            </div>
            ${this.hasChild && this.childOpen ? html`<slot></slot>` : ''}
        `;
    }

    static get styles() {
        return css`

            .btn--highlighted {
                color: var(--theme-white-color);
                --mdc-icon-size: 35px;
            }

            .wrapper {
                display: flex;
                flex-direction: row;
                gap: 10px;
                justify-content: flex-start;
                align-items: center;
                width: 100%;
                height: 100%;
            }

            .mini {
                justify-content: center;
            }

            .btn__label {
                text-align: left;
                font-size: 12px;
                font-weight: 500;
                overflow-x: hidden;
                overflow-y: visible;
                white-space: nowrap;
                text-overflow: ellipsis;
            }

            .btn__label--opened {
                font-weight: 600;
            }

            .btn {
                background-color: var(--main-white-color);
                color: var(--main-primary-color);
                font-family: var(--main-font);
                border-style: none;
                width: 100%;
                height: 25px;
                --mdc-icon-size: 16px;
                cursor: pointer;
                padding: 10px 20px;
            }

            .btn--child {
                padding: 2px 20px;
            }

            .background {
                width: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
            }

            .topActive {
                width: 100%;
                height: 5px;
                background-color: var(--theme-white-color);
                border-radius: 0 0 5px 0px;

            }

            .app-tag {
                background-color: var(--main-secondary-color);
                color: var(--theme-white-color);
                font-size: 10px;
                font-weight: 600;
                padding: 2px 5px;
                border-radius: 5px;
            }

            .mini-arrow {
                margin-left: -10px;
            }

            .bottomActive {
                width: 100%;
                height: 5px;
                background-color: var(--theme-white-color);
                border-radius: 0 5px 0px 0px;
            }

            .active-background {
                background-color: var(--main-primary-color);
            }

            .btn:hover {
                color: var(--main-secondary-color);
                cursor: pointer;

            }

            .btn-active{
                background-color: var(--main-primary-color);
                color: var(--theme-white-color);
            }

            .locked {
                color: var(--main-primary-opacity-color);
            }

            .btn-active:hover {
                color: var(--theme-white-color);
                cursor: pointer;
            }

            .icon--addon {
                color: var(--main-secondary-color);
            }

            .icon--addon-small {
                --mdc-icon-size: 15px;
                z-index: 1;
            }

            .spacer {
                width: 16px;
            }

            .doubleicon {
                display: flex;
                flex-direction: row;
                gap: -5px;
            }

            @media only screen and (max-width: 550px) {
                .btn--hide-on-mobile {
                    display: none;
                }
            }
        `;
    }

    onClick() {
        if (this.hasChild) {
            this.onOpenChild();
        } else {
            const clickEvent: CustomEventInit = {
                bubbles: true,
                composed: true,
                detail: {
                    message: `${this.label} drawer button clicked`,
                },
            };

            if (this.panel) {
                clickEvent.detail.panel = this.panel;
            }

            clickEvent.detail.action = this.action;

            this.dispatchEvent(new CustomEvent('on-button-click', clickEvent));
        }
    }

    onOpenChild() {
        this.childOpen = !this.childOpen;
        this.dispatchEvent(new CustomEvent('on-child-open', {
            bubbles: true,
            composed: true,
            detail: {
                message: `${this.label} child opened`,
            },
        }));
    }
}
